module.exports = __webpack_public_path__ + "static/media/instructions-thumb.b4ac88df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/beers/instructions-thumb.jpg
// module id = 583
// module chunks = 0